<div class="bar-container">
    <mat-progress-bar mode="determinate" [value]="this.appService.progress"></mat-progress-bar>
</div>
